import { SVGProps } from 'react';

const ProjectCollaboration = ({ props }: { props?: SVGProps<SVGSVGElement> }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="534" height="340" viewBox="0 0 534 340" fill="none" {...props}>
    <g clipPath="url(#das-clip)">
      <path fill="url(#das-b)" d="M78 168.803h118v4H78z" />
      <path fill="url(#das-c)" d="M238 168.803h121v4H238z" />
      <path fill="url(#das-d)" d="M401 168h124v4H401z" />
      <g filter="url(#das-blur)">
        <ellipse
          cx="274.699"
          cy="208.814"
          fill="#50024F"
          rx="274.699"
          ry="208.814"
          transform="scale(1 -1) rotate(16.044 2548.398 -202.044)"
        />
      </g>
      <ellipse cx="55" cy="170.303" fill="url(#das-f)" rx="25" ry="25.5" />
      <circle cx="217.5" cy="170.303" r="25.5" fill="url(#das-g)" />
      <circle cx="379.5" cy="170.303" r="25.5" fill="url(#das-h)" />
      <ellipse cx="55" cy="170.303" fill="url(#das-i)" rx="12" ry="11.5" />
      <circle cx="217.5" cy="170.303" r="11.5" fill="url(#das-j)" />
      <circle cx="379.5" cy="170.303" r="11.5" fill="url(#das-k)" />
    </g>
    <defs>
      <linearGradient id="das-b" x1="78" x2="196" y1="170.803" y2="170.803" gradientUnits="userSpaceOnUse">
        <stop stopColor="#50024F" />
        <stop offset="1" stopColor="#F475FD" />
      </linearGradient>
      <linearGradient id="das-c" x1="238" x2="359" y1="170.803" y2="170.803" gradientUnits="userSpaceOnUse">
        <stop stopColor="#50024F" />
        <stop offset="1" stopColor="#F475FD" />
      </linearGradient>
      <linearGradient id="das-d" x1="401" x2="525" y1="170" y2="170" gradientUnits="userSpaceOnUse">
        <stop stopColor="#911593" />
        <stop offset="1" stopColor="#50024F" />
      </linearGradient>
      <linearGradient id="das-f" x1="55" x2="55" y1="144.803" y2="195.803" gradientUnits="userSpaceOnUse">
        <stop stopColor="#781777" />
        <stop offset="1" stopColor="#50024F" />
      </linearGradient>
      <linearGradient id="das-g" x1="217.5" x2="217.5" y1="144.803" y2="195.803" gradientUnits="userSpaceOnUse">
        <stop stopColor="#781777" />
        <stop offset="1" stopColor="#50024F" />
      </linearGradient>
      <linearGradient id="das-h" x1="379.5" x2="379.5" y1="144.803" y2="195.803" gradientUnits="userSpaceOnUse">
        <stop stopColor="#781777" />
        <stop offset="1" stopColor="#50024F" />
      </linearGradient>
      <linearGradient id="das-i" x1="55" x2="55" y1="158.803" y2="181.803" gradientUnits="userSpaceOnUse">
        <stop stopColor="#911593" />
        <stop offset="1" stopColor="#F475FD" />
      </linearGradient>
      <linearGradient id="das-j" x1="217.5" x2="217.5" y1="158.803" y2="181.803" gradientUnits="userSpaceOnUse">
        <stop stopColor="#911593" />
        <stop offset="1" stopColor="#F475FD" />
      </linearGradient>
      <linearGradient id="das-k" x1="379.5" x2="379.5" y1="158.803" y2="181.803" gradientUnits="userSpaceOnUse">
        <stop stopColor="#911593" />
        <stop offset="1" stopColor="#F475FD" />
      </linearGradient>
      <clipPath id="das-clip">
        <rect width="534" height="340" fill="#fff" rx="12.622" />
      </clipPath>
      <filter
        id="das-blur"
        width="940.58"
        height="829.239"
        x="-220.58"
        y="20.983"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_186_1616" stdDeviation="100" />
      </filter>
    </defs>
  </svg>
);

export default ProjectCollaboration;
